module.exports = "<div class=\"container center-align\">\n  <h1>Sablonszerkesztő</h1>\n</div>\n<router-outlet></router-outlet>"